let clevertapInstance;

export const getClevertap = async () => {
    if (!clevertapInstance) {
        const mod = await import("clevertap-web-sdk");
        mod.default.init(process.env.REACT_APP_CLEVERTAP_PROJECT_ID, "in1");
        mod.default.setLogLevel(3);
        clevertapInstance = mod.default;
        window.clevertap = clevertapInstance;
    }
    return clevertapInstance;
};

export const clevertapIdentitySet = async ({ identity }) => {
    try {
        const clevertap = await getClevertap();
        clevertap.onUserLogin.push({
            Site: {
                Identity: identity,
            },
        });
    } catch (err) {
        console.error("CleverTap push event failed:", err);
    }
};


export const pushCleverTapEvent = async ({event_name, event_property = {}}) => {
    try {
        const clevertap = await getClevertap();
        clevertap.event.push(event_name, event_property);
        console.log(`CleverTap event "${event_name}" pushed.`, event_property);
    } catch (err) {
        console.error("CleverTap push event failed:", err);
    }
};